import styles from "./HoneypotField.module.css";
import PropTypes from "prop-types";
import InputField from "./InputField";

export default function HoneypotField({ fieldName, fieldType }) {
  return (
    <div className={styles.main}>
      <InputField
        id={fieldName}
        name={fieldName}
        labelText={fieldName}
        labelAlignment="center"
        type={fieldType}
        tabIndex={-1}
        required={false}
        placeholder={`Enter ${fieldName}`}
        autoComplete="off"
      />
    </div>
  );
}

HoneypotField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldType: PropTypes.string.isRequired,
};
